import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { rootUrl } from "../config.js";

const styles = StyleSheet.create({
	container: {
		position: "relative",
	},
	dismissClickListener: {
		position: "fixed",
		height: "100vh",
		width: "100vw",
		top: 0,
		left: 0,
		zIndex: 1,
	},
	dropdown: {
		width: "100%",
		// height: 40,
		backgroundColor: colors.white,
		border: `1px solid ${colors.gray2}`,
		fontSize: 12,
		lineHeight: 1.75,
		color: colors.black2,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontWeight: "bold",
		paddingTop: 10,
		paddingBottom: 10,
		paddingLeft: 16,
		paddingRight: 16,
		boxSizing: "border-box",
		minHeight: 43,
		backgroundImage: `url(${rootUrl}/images/dropdownArrow.svg)`,
		backgroundRepeat: "no-repeat",
		backgroundPosition: "96% center",
		textAlign: "left",
	},
	option: {
		paddingTop: 4,
		paddingBottom: 4,
		paddingLeft: 32,
		paddingRight: 8,
		fontSize: 12,
		lineHeight: 1.75,
		minHeight: 12,
		color: colors.black2,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		[breakpoints.desktopOnly]: {
			":hover": {
				backgroundColor: colors.tealHighlight,
			},
		},

		border: "none",
		backgroundColor: colors.transparent,
		width: "100%",
		textAlign: "left",

		":focus": {
			outline: "none",
			backgroundColor: colors.tealHighlight,
		},
	},
	optionSubheading: {
		paddingTop: 4,
		paddingBottom: 4,
		paddingLeft: 16,
		paddingRight: 8,
		fontSize: 12,
		lineHeight: 1.75,
		minHeight: 12,
		color: colors.black2,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontWeight: "bold",
		border: "none",
		backgroundColor: colors.transparent,
		width: "100%",
		textAlign: "left",
		opacity: 1,
	},
	optionsContainer: {
		position: "absolute",
		top: 42,
		backgroundColor: colors.white,
		border: `1px solid ${colors.gray2}`,
		zIndex: 2,
		width: "100%",
		paddingTop: 8,
		paddingBottom: 8,
		boxSizing: "border-box",
	},
});

export default class Dropdown extends PureComponent {
	static propTypes = {
		className: PropTypes.string,
		options: PropTypes.arrayOf(
			PropTypes.shape({
				value: PropTypes.string.isRequired,
				label: PropTypes.string.isRequired,
				subheading: PropTypes.bool,
			}),
		),
		selectValue: PropTypes.func.isRequired,
		selectedValue: PropTypes.string.isRequired,
	};

	state = {
		open: false,
	};

	_hideOptions = () => {
		this.setState({
			open: false,
		});
	};

	_toggleOptions = () => {
		this.setState({
			open: this.props.options.length > 0 && !this.state.open,
		});
	};

	_selectedValueLabel = () => {
		const option = this.props.options.filter(opt => opt.value === this.props.selectedValue);
		if (option.length === 0) {
			return "";
		} else {
			return option[0].label;
		}
	};

	_selectOption = value => {
		this.props.selectValue(value);
		this.setState({
			open: false,
		});
	};

	_renderOptions = () => {
		return (
			<div className={css(styles.optionsContainer)}>
				{this.props.options.map(opt => (
					<button
						key={opt.value}
						className={css(opt.subheading ? styles.optionSubheading : styles.option)}
						value={opt.value}
						disabled={opt.subheading}
						onClick={() => this._selectOption(opt.value)}
					>
						{opt.label}
					</button>
				))}
			</div>
		);
	};

	render() {
		return (
			<div className={this.props.className}>
				{this.state.open ? (
					<div className={css(styles.dismissClickListener)} onClick={this._hideOptions} />
				) : null}
				<div className={css(styles.container)}>
					<button className={css(styles.dropdown)} onClick={this._toggleOptions}>
						{this._selectedValueLabel()}
					</button>
					{this.state.open ? this._renderOptions() : null}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Dropdown.js